import { buildPlaidCallbackUrl } from '#client/components/AddCounterPartyModal/utils/plaidUtils';
import { BASE_URL } from '#client/constants/url';

/**
 * Links Plaid with the native app by initializing Plaid Link.
 *
 * @param {object} options - Options for linking Plaid with the native app.
 * @param {string} options.pathName - The original pathname.
 * @param {string} options.unitAccountId - The unit account ID.
 * @param {string} options.modalName - The modal name for Plaid callback (optional).
 * @throws {Error} Throws an error if initPlaidLink is not available in the webview.
 */
export const linkPlaidWithNativeApp = ({ pathName, unitAccountId, modalName }) => {
  const { initPlaidLink } = window.NativeApp || {};
  const { pathFormatted } = buildPlaidCallbackUrl(pathName, modalName);

  const redirectURL = `${BASE_URL}${pathFormatted}`;
  if (typeof initPlaidLink === 'function') {
    initPlaidLink(redirectURL, unitAccountId);
  } else {
    throw new Error(`Cannot init initPlaidLink in webview at redirectURL: ${redirectURL}`);
  }
};

/**
 * Initiates the relinking process with Plaid in a native app.
 *
 * @param {object} options - The options for relinking.
 * @param {string} options.pathName - The pathname for the redirect URL.
 * @param {string} options.unitAccountId - The unit account ID.
 * @param {string} options.counterpartyId - The counterparty ID.
 *
 * @throws {Error} Throws an error if the initiation of Plaid relink encounters issues.
 */
export const relinkPlaidWithNativeApp = ({ pathName, unitAccountId, counterpartyId }) => {
  const { initPlaidRelink } = window.NativeApp || {};
  const redirectURL = `${BASE_URL}${pathName}`;

  if (typeof initPlaidRelink === 'function') {
    initPlaidRelink(redirectURL, unitAccountId, counterpartyId);
  } else {
    throw new Error(`Cannot init initPlaidRelink in webview at redirectURL: ${redirectURL}`);
  }
};
